import { LoginCallback, SecureRoute } from "@okta/okta-react";
import React from "react";
import { Redirect } from "react-router";
import { Route, Switch } from "react-router-dom";
import TPFooter from "../Views/Footer/tpFooter";
import ConnectedTPHeader from "../Views/Header/connected-tpHeader";
import connectedSearchTransaction from "../Views/SearchTransaction/connected-search-transaction";
import TPMain from "../Views/TPMain/connected-tpMain";
import ConnectedTransaction from "../Views/Transaction/connected-transaction.js";

export function TPRoutes() {
  return (
    <div>
      <ConnectedTPHeader />
      <Switch>
        <SecureRoute path="/" exact component={TPMain} />
        <SecureRoute
          path="/transaction"
          exact
          component={ConnectedTransaction}
        />
        <SecureRoute
          path="/transactions"
          exact
          component={connectedSearchTransaction}
        />
        <SecureRoute
          path="/transaction/view"
          exact
          component={ConnectedTransaction}
        />
        <Route path="/implicit/callback" component={LoginCallback} />
        <Route render={() => <Redirect to={{ pathname: "/" }} />} />
      </Switch>
      <TPFooter />
    </div>
  );
}
